import requestAction from '../../utils/requestAction'

export const deletePreorder = (preorderId: number) =>
  requestAction('PREORDER_DELETE')(
    `preorders/${preorderId}`,
    'DELETE')

